import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";

import Login from './components/Login';
import SearchBar from './components/SearchBar';
import Console from './containers/Console';
import Report from './containers/Report';

const Routes = ({ pdfUrl, pdfJSON,  uploadPath, afterUpload }) =>
  <Switch>
    {/* <Route path="/console" render={ () =>  <PdfApp inputPdf={ pdfUrl } inputJSON ={ pdfJSON } />} /> */}
    { /* Finally, catch all unmatched routes */ }
    <Route path="/report/" component={Report} />
    <Route path="/console/"  component={Console} />
    <Route path="/login/" component={Login} />
    <Route component={Report} />
  </Switch>;

export default Routes;
